<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (processingPurpose) {
    <div class="detail-page-action-bar">
        @if (permissions.canSave) {
            <button class="btn btn-cerrix" (click)="save()">
                <i class="fas fa-save"></i>
                <span data-uiid="dmdetail-save" class="d-none d-lg-inline"
                    >{{ 'datamanagement.detail.saveDataProcessingBtn' | transloco }}</span
                >
            </button>
        }

        @if (processingPurpose.ID > 0) {
            <span class="date-edited">
                {{ 'datamanagement.detail.lastSave' | transloco: { date: (processingPurpose.lastSaveDate | dateTimeFormat) } }}
            </span>
        }
    </div>

    <div
        class="datamanagement-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div
            class="datamanagement-screens"
            [attr.name]="'datamanagement.detail.menuDataProcessing' | transloco"
            menuicon="fas fa-database"
            menusystemsubmenu
        >
            <div [attr.name]="'datamanagement.detail.menuDetails' | transloco" menuicon="fas fa-info-circle" menuItemId="menuItemDetails" menusystemitem>
                <datamanagement-detail-main
                    [processingPurpose]="processingPurpose"
                    [parentForm]="parentForm"
                    [permissions]="permissions"
                >
                </datamanagement-detail-main>
            </div>
            @if (processingPurpose.ID > 0) {
                <div
                    [attr.name]="'datamanagement.detail.menuManageDataStructures' | transloco"
                    menuItemId="manageDataStructures"
                    menuicon="fas fa-stream"
                    menusystemitem
                >
                    <processingpurpose-datastructure
                        [processingPurpose]="processingPurpose"
                        [permissions]="permissions"
                        #dataStructureComponent
                    >
                    </processingpurpose-datastructure>
                </div>
            }
            <div
                class="datamanagement-screens"
                [attr.name]="'datamanagement.detail.menuLinks' | transloco"
                menuicon="fas fa-link"
                menusystemsubmenu
            >
                @if (processingPurpose.ID > 0) {
                    <div
                        [attr.name]="'datamanagement.detail.menuMeasuresOfImprovement' | transloco"
                        menuicon="fas fa-tasks"
                        menuItemId="dmMois"
                        menusystemitem
                    >
                        <linked-moi-overview
                            [moiType]="dmMoiType"
                            [parentGuid]="processingPurpose.guid"
                            [canAdd]="permissions.canAddMoi"
                            [canDelete]="permissions.canDeleteMoi"
                            #dmMoisComponent
                        >
                        </linked-moi-overview>
                    </div>
                    <div
                        [attr.name]="'datamanagement.detail.menuRisks' | transloco"
                        menuItemId="risks"
                        menuicon="fas fa-exclamation-triangle"
                        menusystemitem
                    >
                        <datamanagement-risks
                            #risksComponent
                            [model]="processingPurpose"
                            [permissions]="permissions"
                        >
                        </datamanagement-risks>
                    </div>
                    <div
                        [attr.name]="'datamanagement.detail.menuControls' | transloco"
                        menuItemId="controls"
                        menuicon="fas fa-shield-alt"
                        menusystemitem
                    >
                        <datamanagement-controls
                            #controlsComponent
                            [model]="processingPurpose"
                            [permissions]="permissions"
                        >
                        </datamanagement-controls>
                    </div>
                    <div
                        [attr.name]="'datamanagement.detail.menuDocuments' | transloco"
                        menuItemId="documents"
                        menuicon="far fa-file"
                        menusystemitem
                    >
                        @if (documents) {
                            <div>
                                <document-manager-old
                                    [(Documents)]="processingPurpose.documents"
                                    [permissions]="permissions.documentPermissions"
                                    (DocumentsChange)="checkDirty()"
                                    [DocumentTypeTargets]="targetModule"
                                ></document-manager-old>
                            </div>
                        } @else {
                            <div class="fancy-loader submodule"></div>
                        }
                    </div>
                    <div
                        [attr.name]="'datamanagement.detail.menuHyperlinks' | transloco"
                        [attr.menuItemID]="hyperlinksMenuItemId"
                        menuicon="fas fa-external-link-alt"
                        menusystemitem
                    >
                        @if (processingPurpose.Hyperlinks) {
                            <div>
                                <hyperlink-manager
                                    [(Hyperlinks)]="processingPurpose.Hyperlinks"
                                    (HyperlinksChanged)="checkHyperlinksDirty($event)"
                                    [TargetModule]="targetModule"
                                ></hyperlink-manager>
                            </div>
                        } @else {
                            <div>
                                <div class="fancy-loader"></div>
                            </div>
                        }
                    </div>
                }
            </div>

            @if (processingPurpose.ID > 0) {
                <div [attr.name]="'datamanagement.detail.menuHistory' | transloco" menuicon="fas fa-history" menusystemsubmenu>
                    <div
                        [attr.name]="'datamanagement.detail.menuDataProcessingDetailsHistory' | transloco"
                        menuicon="fas fa-bolt"
                        menusystemitem
                        menuItemId="detailsHistory"
                    >
                        <app-history-overview
                            [Id]="processingPurpose.guid"
                            [historyDataService]="_datamanagementDS"
                            ExtraParam="detail"
                            #historyDetailOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                    <div
                        [attr.name]="'datamanagement.detail.menuManageDataStructuresHistory' | transloco"
                        menuicon="fas fa-stream"
                        menusystemitem
                        menuItemId="mdsHistory"
                    >
                        <app-history-overview
                            [Id]="processingPurpose.guid"
                            [historyDataService]="_datamanagementDS"
                            ExtraParam="mds"
                            #historyMdsOverviewComponent
                        >
                        </app-history-overview>
                    </div>
                </div>

                <div
                    data-uiid="dmdetail-options"
                    [attr.name]="'datamanagement.detail.menuOptions' | transloco"
                    menuItemId="options"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="data processing"
                        [objectName]="
                            processingPurpose ? processingPurpose.name : 'data processing'
                        "
                        [allowDelete]="permissions.canDelete"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
